<template>
    <div class="header-box">
        <div class="logo-box">
            <a href="/home/index">
              <el-image style=" height: 32px" :src="logo"/>
            </a>
        </div>
        <div class="header-right">
            <a target="_blank" href="/map" v-if="type!=='map'" class="map-btn">
                <i class="iconfont icon-ditu"></i>
                <span target="_blank" href="/map">地图搜索</span>
            </a>
            <div v-else>数据时间：{{ time }}</div>
            <div class="user-box">
                <header-info
                  :userName="userName"
                  @mouseenter="userInfo"
                  @mouseleave="clearUserInfo"
                />

            </div>
            <div class="login-box-btn">
                               <!-- <span @click="isshowModify=true">修改密码</span> -->
                <span @click="loginOut">退出登录</span>
            </div>
        </div>
        <div class="modify-password-box" v-if="isshowModify">
            <div class="modify-pwd-box">
                <p class="modify-text">密码修改</p>
                <div class="modify-box">
                    <div class="modify-error error" v-if="errMsg"><span><b>×</b></span><i class="error-cue">{{
                            errMsg
                        }}</i></div>
                    <div class="modify-input">
                        <span>登录账号：</span>
                        <input type="text" placeholder="请输入用户名" v-model="editParams.userName" maxlength="20"
                               disabled>
                    </div>
                    <div class="modify-input">
                        <span>登录密码：</span>
                        <input type="password" placeholder="请输入密码" v-model="editParams.password" maxlength="20">
                    </div>
                    <div class="modify-input">
                        <span>新密码：</span>
                        <input type="password" placeholder="请输入新密码" v-model="editParams.newPassword"
                               maxlength="20">
                    </div>
                    <div class="modify-input">
                        <span>确认新密码：</span>
                        <input type="password" placeholder="请输入确认密码" v-model="editParams.comfirmPassword"
                               maxlength="20">
                    </div>
                    <el-button type="primary" href="javascript:void(0);" class="btn-modify" v-on:click="modify()"
                               :disabled="disabled">确 定
                    </el-button>
                </div>
                <div class="close-user-box" @click="isshowModify=false">×</div>
            </div>

        </div>
        <div class="userMess" 
        @mouseenter="userInfo2"
        @mouseleave="clearUserInfo2"
         v-if="userInfos">
            <div class="userInfo">
                    <div class="name">
                        <el-row :gutter="1">
                            <!-- <el-col :span="2"><div class="grid-content ep-bg-purple" /></el-col> -->
                            <el-col :span="9"><div class="grid-content ep-bg-purple" />
                            <span><u class="icon-name"></u></span>
                            账号</el-col>
                            <el-col :span="9"><div class="grid-content ep-bg-purple" />{{userName}}</el-col>
                        </el-row>
                    </div>
                    <div class="info">
                        <el-row :gutter="1" class="info_item">
                            <el-col :span="9"><div class="grid-content ep-bg-purple" />
                            <span><u class="icon-phone"></u></span>
                            手机号
                            </el-col>
                            <el-col :span="9"><div class="grid-content ep-bg-purple" />{{phone}}</el-col>
                        </el-row>
                        <!-- <el-row :gutter="1" class="info_item">
                            <el-col :span="9"><div class="grid-content ep-bg-purple" />
                            <span><u class="icon-email"></u></span>
                            邮箱</el-col>
                            <el-col :span="11"><div class="grid-content ep-bg-purple" />{{email}}</el-col>
                        </el-row> -->
                        <!-- <el-row :gutter="1" class="info_item">
                            <el-col :span="9"><div class="grid-content ep-bg-purple" />
                            <span><u class="icon-companyName"></u></span>
                            公司名称</el-col>
                            <el-col :span="11"><div class="grid-content ep-bg-purple" />{{companyName}}</el-col>

                        </el-row> -->
                        <el-row :gutter="1" class="info_item">
                            <el-col :span="9"><div class="grid-content ep-bg-purple" />
                            <span><u class="icon-start"></u></span>
                            账号开通时间</el-col>
                            <el-col :span="9"><div class="grid-content ep-bg-purple" />{{startTime}}</el-col>
                        </el-row>
                        <el-row :gutter="1" class="info_item">
                            <el-col :span="9"><div class="grid-content ep-bg-purple" />
                            <span><u class="icon-end"></u></span>
                            账号有效期至</el-col>
                            <el-col :span="9"><div class="grid-content ep-bg-purple" />{{endTime}}</el-col>
                        </el-row>
                    </div>
                <!-- <div class=" close-userInfo" @click="userInfos=false">×</div> -->
            </div>

        </div>
    </div>
</template>

<script setup>
import logo from '@/assets/images/logo.png'
import request from "@/service/request";
import HeaderInfo from "@/components/header/headerInfo.vue";
import {useRoute, useRouter} from "vue-router";
import {onMounted, ref} from "vue";
import { getClientHeadData } from "@/service/api";

const userName = localStorage.getItem('userName')
const isshowModify = ref(false)
const userInfos = ref(false)
const props = defineProps({
    type: {
        type: String,
        default: ''
    }
})
let time = localStorage.getItem('time')

const phone = localStorage.getItem('phone')
const email = localStorage.getItem('email')
const companyName = localStorage.getItem('companyName')
const startTime = localStorage.getItem('startTime')
const endTime = localStorage.getItem('endTime')
// const loading = localStorage.getItem('userName')

/**修改密码**/
const errMsg = ref('')
const disabled = ref(false)
const editParams = ref({
    userName: '',
    password: '',
    newPassword: '',
    comfirmPassword: ''
})



async function modify() {
    disabled.value = true
    if (!editParams.value.password) {
        errMsg.value = '请输入密码';
        disabled.value = false
        return;
    }
    if (!editParams.value.newPassword) {
        errMsg.value = '请输入新密码';
        disabled.value = false
        return;
    }
    if (!editParams.value.comfirmPassword) {
        errMsg.value = '请输入确认密码';
        disabled.value = false
        return;
    }
    if (editParams.value.newPassword !== editParams.value.comfirmPassword) {
        errMsg.value = '输入的新密码和确认密码不一致';
        disabled.value = false
        return;
    }

    try {
        let result = await request({
            url: `/system/user/profile/updatePwd?oldPassword=${editParams.value.password}&newPassword=${editParams.value.newPassword}`,
            method: 'put'
        })
        localStorage.removeItem("token");
        localStorage.removeItem("roleName");
        localStorage.removeItem("userName");
        localStorage.removeItem("phone");
        localStorage.removeItem("email");
        localStorage.removeItem("companyName");
        localStorage.removeItem("startTime");
        localStorage.removeItem("endTime");
        location.href = "/login";
    } catch (e) {
        errMsg.value = e.data.msg;
        disabled.value = false
    } finally {
        disabled.value = false
    }
}
const router = useRouter()
const userInfo = () => {
    console.log('55555');
    userInfos.value = true
}
const userInfo2 = () => {
    console.log('22222');
    userInfos.value = true
    xianqin.value = false
}
const xianqin = ref(true)
const clearUserInfo = () => { 
    setTimeout(function(){
        if(xianqin.value) {
            userInfos.value = false
            
        }
    },100)
}
const clearUserInfo2 = () => {
        userInfos.value = false
        xianqin.value = true
}


// 退出
const loginOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("roleName");
    localStorage.removeItem("userName");
    location.href = "/login";
}
</script>

<style lang="less" scoped>
@import '../../assets/css/login.css';

.header-box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo-box {
        display: flex;
        align-items: center;

        .logo-text {
            display: inline-block;
            margin-left: 16px;
            padding-left: 16px;
            font-size: 16px;
            font-weight: bold;
            color: #FFFFFF;
            border-left: 1px solid #fff;
        }
    }

    .header-right {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: 400;
        flex: 1;
        color: #FFFFFF;
        justify-content: flex-end;
        position: relative;

        .map-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 108px;
            height: 28px;
            background: #1477C9;
            border-radius: 14px;
            font-size: 14px;
            color: #FFFFFF;
            cursor: pointer;
            text-decoration: none;

            .icon-ditu {
                margin-right: 5px;
            }

            & > span {
                color: #FFFFFF;
            }
        }

        .user-box {
            padding: 0 48px;
            border-right: 2px solid #637AAD;
        }

        .login-box-btn {
            cursor: pointer;
            padding-right: 10px;

            span {
                padding-left: 40px;
            }

        }
    }

}

.userInfo {
        padding: 10px 0 10px 0;
}
.name div {
    margin-bottom: 8px;
    margin-left: 16px;
}
.info div {
    margin-bottom: 8px;
    margin-left: 16px;
}

.userInfo {
    font-size: 15px;
    background-color: #f0f3fa;
    padding-left: 10px;
    margin-top: 15px;
}
.userMess {
    width: 330px;
    height: 230px;
    /* padding: 10px; */
    position: absolute;
    top: 61px;
    right: 48px;
    z-index: 999999;
    border-radius: 14px;
    border: 1px red;
    overflow: hidden;
    background-color: #f0f3fa;
    box-shadow: 0px 0px 10px -3px rgba(0, 0, 0, 0.7)
}

.icon-name,
.icon-phone,
.icon-email,
.icon-companyName {
  display: inline-block;
  width: 18px;
  height: 20px;
  margin-left: 6px;
  background: url(../../assets/images/applyIcon.png) no-repeat 0 0;
  background-size: 116px;
  vertical-align: sub;
}

.icon-phone {
  background-position: -20px;
}
.icon-companyName {
  background-position: -79px;
}
.icon-email {
  background-position: -59px;
}
.icon-start,
.icon-end {
  display: inline-block;
  width: 18px;
  height: 20px;
  margin-left: 6px;
  background: url(../../assets/images/startTime.png) no-repeat 0 0;
  background-size: 40px;
  vertical-align: sub;
}
.icon-end {
  background-position: -20px;
}
</style>